import { AppConstant } from "../Shared/Utils/AppConstant";
import "./App.scss";
import truck from '../Shared/images/truck.png'
import ogefrem from "../Shared/images/ogefrem.png"
import { useTranslation } from "react-i18next";

export const Landing = () => {
  const LinkURL = AppConstant.ServerURL;
  const {t} = useTranslation()
  return (
    <>
      <div className="mx-auto">
        <section className="bg-white dark:bg-gray-900">
          <div className="flex px-2 lg:px-8 pt-20 pb-8 lg:py-16 lg:pt-16 justify-between items-centerw-full lg:w-10/12 mx-auto">
            <div className="place-self-center lg:w-6/12">
              <h1 className="max-w-2xl mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl xl:text-6xl dark:text-white text-blue-500">
                {t('welcome')}
              </h1>
              <p className="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                {t('description')}
                
              </p>
              <div className="sm:flex sm:space-x-4 my-8">
                <a
                  href="/auth/register"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center w-full px-5 py-3 text-sm font-medium text-center bg-primary-500 text-white border border-gray-200 rounded-lg sm:w-auto hover:bg-yellow-500 focus:ring-4 focus:ring-gray-100 dark:text-white dark:border-gray-700 dark:hover:bg-gray-700 dark:focus:ring-gray-800 uppercase"
                >
                  {t('signup')}
                </a>
              </div>
            </div>
            <div className="hidden lg:mt-0 lg:w-6/12 lg:flex ">
              <img className="mx-auto"
                src={truck}
                alt="shipment truck"
              />
            </div>
          </div>
        </section>

       <section className="bg-white dark:bg-gray-900">
        <img src={ogefrem} alt="Ogefrem" className="w-full mx-auto"/>
       </section>
      </div>
    </>
  );
};
